import PayoutsAdmin from "@/components/admin/PayoutsAdmin";

const EarningsPayouts = () => <PayoutsAdmin />;

export default EarningsPayouts;
